export default "__VITE_ASSET__BigzMqqr__"